module.exports = __webpack_public_path__ + "img/polokwane-city-logo-icon.a19935ee.png";